import { useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import DatePicker from 'react-datepicker';

import { CalendarIcon, ChevronDownIcon, DoubleChevronLeftIcon, DoubleChevronRightIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { TextBold, TextSemiBold } from 'UiKit/typography';

import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles.module.css';

const InputYearMonthPicker = ({
  label,
  placeholder = 'MMMM yyyy',
  dateFormat = 'MMMM yyyy',
  onChange,
  value,
  isDisabled,
  error,
  isRequired,
  register,
  margin,
  className,
  containerClassname,
  titleClassname,
  icon = 'chevron',
  ...props
}) => {
  const [showYearPicker, setShowYearPicker] = useState(false);
  const isError = !isEmpty(error);
  const isValueSettled = !isEmpty(value);
  const { isOpen, onClose, onOpen } = useDisclosure();

  const onOpenDatePicker = () => onOpen();

  const onSelectDatePicker = (value) => {
    if (showYearPicker) {
      setShowYearPicker(false);
    } else {
      onChange(value);
      onClose();
    }
  };

  const onClickOutside = () => {
    setShowYearPicker(false);
    onClose();
  };

  const CustomHeader = (props) => {
    const { decreaseYear, increaseYear } = props;
    return (
      <Flex className={styles['custom-header__container']}>
        <Box onClick={decreaseYear} className={styles['custom-header__picker']}>
          <DoubleChevronLeftIcon
            color="var(--color-neutral40)"
            style={{
              pointerEvents: 'none',
            }}
          />
        </Box>
        <Box onClick={() => setShowYearPicker(true)} className={styles['custom-header__picker']}>
          <TextBold>{props.date.getFullYear()}</TextBold>
        </Box>
        <Box onClick={() => increaseYear()} className={styles['custom-header__picker']}>
          <DoubleChevronRightIcon
            color="var(--color-neutral40)"
            style={{
              pointerEvents: 'none',
            }}
          />
        </Box>
      </Flex>
    );
  };

  const renderYearContent = (year) => {
    return <Box className={styles['year-month-picker__year-content']}>{year}</Box>;
  };

  return (
    <Box
      margin={margin}
      className={`${className || ''}
        ${styles['year-month-component__container']} 
        ${isDisabled && styles['year-month-component__container--disabled']} 
        ${isError && styles['year-month-component__container--error']}
      `}
    >
      <Condition statement={label}>
        <TextSemiBold className={`${styles['text__title']} ${titleClassname}`}>
          {label}{' '}
          <Condition statement={isRequired}>
            <span>*</span>
          </Condition>
        </TextSemiBold>
      </Condition>

      <Box
        className={`${containerClassname} ${styles['year-month-custom__container']} year-month-custom__container ${
          isOpen ? styles['year-month-custom__container-open'] : ''
        } ${value ? styles['year-month__container--selected'] : styles['year-month__container--value']}`}
        background={value ? 'white' : 'var(--color-semantic-background)'}
      >
        <DatePicker
          selected={value}
          showMonthYearPicker={!showYearPicker}
          showYearPicker={showYearPicker}
          dateFormat={dateFormat}
          yearItemNumber={12}
          open={isOpen && !isDisabled}
          onSelect={onSelectDatePicker}
          onInputClick={onOpen}
          onClickOutside={onClickOutside}
          placeholder={placeholder}
          showPopperArrow={false}
          className={`${styles['year-month-picker__input-field']} ${
            isValueSettled ? styles['year-month-picker__input-field--selected'] : styles['year-month-picker__input-field--empty']
          }`}
          renderYearContent={renderYearContent}
          renderCustomHeader={CustomHeader}
          calendarClassName={styles['year-month-picker__calendar-classname']}
          placeholderText={placeholder}
          {...props}
          {...register}
        />

        <Condition statement={icon === 'chevron'}>
          <ChevronDownIcon
            className="calendar__icon"
            color="var(--color-neutral70)"
            size="16px"
            onClick={() => {
              if (!isDisabled) onOpenDatePicker();
            }}
          />
        </Condition>

        <Condition statement={icon === 'calendar'}>
          <CalendarIcon
            className="calendar__icon"
            color="var(--color-neutral70)"
            size="16px"
            onClick={() => {
              if (!isDisabled) onOpenDatePicker();
            }}
          />
        </Condition>
      </Box>
    </Box>
  );
};

export default InputYearMonthPicker;
